<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-60 o-dialog--lg-50 o-dialog--xl-36"
    title="申请修改"
    :visible.sync="dialogVisible"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="right"
      label-width="110px"
      label-suffix="："
      class="c-form"
    >
      <el-form-item
        label="修改原因"
        prop="xgyy"
        class="c-form__item"
      >
        <el-input
          v-model.trim="form.xgyy"
          type="textarea"
          :rows="4"
          maxlength="500"
          show-word-limit
          placeholder="请输入申请修改原因"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        type="primary"
        btn-text="提交"
        :auth-type="false"
        @click="submit"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog"
      />
    </div>
  </el-dialog>
</template>

<script>
import { projectService } from './project.service.js';

export default {
  name: 'JxxfJcProjectModificationDialog',
  props: { xmId: { type: String, required: true } },
  data () {
    return {
      loading: false,
      dialogVisible: true,
      form: { xgyy: '' },
      rules: { xgyy: [this.$validUtils.required('申请修改原因')] }
    };
  },
  methods: {
    submit () {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.loading = true;
        projectService.modification(this.xmId, this.form)
          .then(() => {
            this.$message.success('申请修改成功');
            this.$emit('success');
            this.closeDialog();
          })
          .finally(() => { this.loading = false; });
      });
    },
    closeDialog () { this.$emit('close'); }
  }
};
</script>
